export const isEnableFullDiagnostic = (user: any) => user?.countryCode === "BR";
